<template>
    <div>
        <el-row :gutter="10" class="u-mb-15">
            <el-col :xs="24" :sm="12" :md="10">
                <label>Etapa</label>
                <el-select v-model="etapaId" filterable placeholder="Selecione a etapa" style="width: 100%;" @change="load">
                    <el-option v-for="e in etapas" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="12" :md="14" class="u-text-right" style="padding-top: 22px;">
                <el-button v-if="etapaId" type="primary" size="small" plain icon="el-icon-plus" @click="adicionar">
                    ADICIONAR {{ ehEixos ? 'EIXO TEMÁTICO' : 'DISCIPLINA' }}
                </el-button>
            </el-col>
        </el-row>

        <el-alert v-if="!etapas.length" type="info" :closable="false"
            title="Cadastre ao menos uma etapa na aba anterior para poder montar os componentes curriculares."></el-alert>

        <template v-else-if="etapaId">
            <el-alert type="info" :closable="false" class="u-mb-15"
                :title="ehEixos
                    ? 'Esta matriz é organizada por EIXOS TEMÁTICOS — os componentes vêm do cadastro de eixos.'
                    : 'Esta matriz é organizada por DISCIPLINAS — os componentes vêm do cadastro de disciplinas.'"></el-alert>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 70px;" class="u-text-center">Ordem</th>
                            <th style="width: 28%;">{{ ehEixos ? 'Eixo Temático' : 'Disciplina' }}</th>
                            <th>Orientação Curricular</th>
                            <th style="width: 130px;" class="u-text-center">Carga h/ano</th>
                            <th style="width: 130px;" class="u-text-center">Aulas semanais</th>
                            <th style="width: 190px;">Tipo de Avaliação</th>
                            <th style="width: 90px;" class="u-text-center">Objetivos</th>
                            <th style="width: 60px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="status">
                        <tr v-for="(l, i) in linhas" :key="i">
                            <td class="u-text-center">
                                <el-input-number v-model="l.ordem_boletim" :min="0" :controls="false" size="mini" style="width: 56px;"></el-input-number>
                            </td>
                            <td>
                                <el-select v-if="ehEixos" v-model="l.eixo_tematico_id" filterable placeholder="Selecione" size="small" style="width: 100%;">
                                    <el-option v-for="x in init.eixosTematicos" :key="x.id" :label="x.nome" :value="x.id"></el-option>
                                </el-select>
                                <el-select v-else v-model="l.area_conhecimento_id" filterable placeholder="Selecione" size="small" style="width: 100%;">
                                    <el-option v-for="d in init.disciplinas" :key="d.id" :label="d.nome_area" :value="d.id"></el-option>
                                </el-select>
                            </td>
                            <td>
                                <el-select v-model="l.orientacao_curricular" size="small" style="width: 100%;">
                                    <el-option value="base_nacional_comum" label="Base Nacional Comum"></el-option>
                                    <el-option value="parte_diversificada" label="Parte Diversificada"></el-option>
                                </el-select>
                            </td>
                            <td class="u-text-center">
                                <el-input v-mask="'######'" v-model="l.carga_horaria_anual" size="mini" style="width: 100px;" placeholder="—"></el-input>
                            </td>
                            <td class="u-text-center">
                                <el-input v-mask="'###'" v-model="l.aulas_semanais" size="mini" style="width: 100px;" placeholder="—"></el-input>
                            </td>
                            <td>
                                <!-- BLOCO B, item 92. Vazio = a turma decide. Escolher aqui NÃO
                                     altera nenhuma turma já existente. -->
                                <el-select v-model="l.tipo_avaliacao_id" size="small" style="width: 100%;" clearable filterable placeholder="Da turma">
                                    <el-option v-for="t in tiposAvaliacao" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                                </el-select>
                            </td>
                            <td class="u-text-center">
                                <el-tag v-if="l.objetivos_count" size="mini" type="info">{{ l.objetivos_count }}</el-tag>
                                <span v-else style="color: #909399;">—</span>
                            </td>
                            <td class="u-text-center">
                                <el-button type="danger" size="mini" plain icon="el-icon-delete" @click="remover(i)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!linhas.length">
                            <td colspan="8" class="u-text-center" style="padding: 18px; color: #909399;">
                                Nenhum componente nesta etapa.
                            </td>
                        </tr>
                    </tbody>
                    <tfoot v-if="status && totais">
                        <tr style="font-weight: bold; background: #fafafa;">
                            <td colspan="3" class="u-text-right">
                                Totais &nbsp;
                                <span style="font-weight: normal; color: #909399;">
                                    ({{ totais.base_nacional_comum }} base nacional comum · {{ totais.parte_diversificada }} parte diversificada)
                                </span>
                            </td>
                            <td class="u-text-center">{{ totais.carga_horaria_anual }}</td>
                            <td class="u-text-center">{{ totais.aulas_semanais }}</td>
                            <td colspan="3"></td>
                        </tr>
                    </tfoot>
                </table>

                <div v-if="!status" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>

            <el-row class="u-mt-15">
                <el-col :xs="24" :sm="12">
                    <el-button type="warning" plain icon="el-icon-download" @click="abrirMaterializacao">
                        GERAR GRADE DE UMA TURMA
                    </el-button>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button @click="load">DESFAZER</el-button>
                    <el-button class="u-ml-10" type="primary" icon="el-icon-check" @click="salvar">SALVAR COMPONENTES</el-button>
                </el-col>
            </el-row>
        </template>

        <el-alert v-else type="info" :closable="false" title="Selecione uma etapa para montar os componentes curriculares."></el-alert>

        <!-- ======================= MODAL DE MATERIALIZAÇÃO ======================= -->
        <el-dialog title="GERAR GRADE PADRÃO DA TURMA" :visible.sync="modalVisivel" width="640px" :close-on-click-modal="false">
            <el-alert class="u-mt-20" type="info" :closable="false"
                title="Copia os componentes desta etapa para a Grade Padrão da turma escolhida. Só aparecem turmas ATIVAS do período letivo selecionado, do curso vinculado à etapa e das instituições às quais você tem acesso."></el-alert>

            <el-form class="u-mt-20" label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Turma de destino">
                            <el-select v-model="turmaId" filterable placeholder="Selecione a turma" style="width: 100%;" :loading="carregandoTurmas">
                                <el-option v-for="t in turmas" :key="t.id" :label="rotuloTurma(t)" :value="t.id"></el-option>
                            </el-select>
                            <div v-if="!carregandoTurmas && !turmas.length" style="color: #909399; font-size: 12px;">
                                Nenhuma turma elegível encontrada para o curso desta etapa.
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <span slot="footer">
                <el-button @click="modalVisivel = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" :disabled="!turmaId" @click="materializar(false)">GERAR GRADE</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        matrizId: { type: Number, required: true },
        init: { type: Object, required: true },
        organizacaoDidatica: { type: String, default: 'disciplinas' }
    },
    data: () => ({
        status: false,
        etapas: [],
        etapaId: null,
        linhas: [],
        totais: null,
        organizacaoServidor: null,
        modalVisivel: false,
        carregandoTurmas: false,
        turmas: [],
        turmaId: null,
        tiposAvaliacao: []
    }),
    computed: {
        /**
         * A organização vem do backend junto com os componentes (fonte da verdade).
         * Enquanto nada foi carregado, usa a prop da aba de dados gerais.
         */
        ehEixos () {
            const org = this.organizacaoServidor || this.organizacaoDidatica
            return org === 'eixos_tematicos'
        }
    },
    mounted () {
        this.carregarEtapas()
        // BLOCO B, item 92 — catálogo de tipos de avaliação para o componente.
        this.$axios.get(
            `${this.$store.state.config.baseUrlApi}/api/tipo-avaliacao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.tiposAvaliacao = r.data || [] }).catch(() => {})
    },
    methods: {
        msgErro (r) {
            if (!r.data || !r.data.erro) return null
            return typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text
        },
        /** Marcador de protocolo do backend para operações que exigem confirmação. */
        pedeConfirmacao (msg) {
            return !!msg && msg.indexOf('Confirme a operação para prosseguir.') !== -1
        },
        carregarEtapas () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapas/${this.matrizId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.etapas = Array.isArray(r.data) ? r.data : []
                if (this.etapas.length === 1) {
                    this.etapaId = this.etapas[0].id
                    this.load()
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        load () {
            if (!this.etapaId) return
            this.status = false
            this.linhas = []
            this.totais = null

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/componentes/${this.etapaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const erro = this.msgErro(r)
                if (erro) {
                    window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                    this.status = true
                    return
                }
                const d = r.data || {}
                this.organizacaoServidor = d.organizacao_didatica || null
                this.totais = d.totais || null
                this.linhas = (Array.isArray(d.componentes) ? d.componentes : []).map(c => ({
                    area_conhecimento_id: c.area_conhecimento_id,
                    eixo_tematico_id: c.eixo_tematico_id,
                    orientacao_curricular: c.orientacao_curricular || 'base_nacional_comum',
                    carga_horaria_anual: c.carga_horaria_anual,
                    aulas_semanais: c.aulas_semanais,
                    tipo_avaliacao_id: c.tipo_avaliacao_id || '',
                    ordem_boletim: c.ordem_boletim,
                    situacao: c.situacao === false ? false : true,
                    objetivos_count: c.objetivos_count || 0
                }))
                this.status = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        adicionar () {
            this.linhas.push({
                area_conhecimento_id: null,
                eixo_tematico_id: null,
                orientacao_curricular: 'base_nacional_comum',
                carga_horaria_anual: null,
                aulas_semanais: null,
                tipo_avaliacao_id: '',
                ordem_boletim: this.linhas.length + 1,
                situacao: true,
                objetivos_count: 0
            })
        },
        remover (i) {
            this.linhas.splice(i, 1)
        },
        salvar () {
            this.enviar(false)
        },

        // ---------------------------------------------------------- materialização
        rotuloTurma (t) {
            const turno = (this.$CONSTANTS.TURNO && this.$CONSTANTS.TURNO[t.turno] !== undefined)
                ? ' (' + this.$CONSTANTS.TURNO[t.turno] + ')' : ''
            const inst = t.instituicao ? ' — ' + t.instituicao.nome : ''
            return `${t.nome}${turno}${inst}`
        },
        abrirMaterializacao () {
            this.turmaId = null
            this.turmas = []
            this.modalVisivel = true
            this.carregandoTurmas = true

            // O período letivo é o selecionado no cabeçalho; o backend cai no período
            // base do sistema se nada for enviado.
            const periodo = (this.$store.state.config.periodo && this.$store.state.config.periodo.id)
                ? '?periodo_letivo_id=' + this.$store.state.config.periodo.id : ''

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/turmasParaMaterializar/${this.etapaId}${periodo}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.carregandoTurmas = false
                const erro = this.msgErro(r)
                if (erro) { window.eventBus.$emit('alert', { msg: erro, type: 'warning' }); return }
                this.turmas = Array.isArray(r.data) ? r.data : []
            }).catch(e => { this.carregandoTurmas = false; this.$store.commit('throwException', e) })
        },
        /**
         * Toda a validação (curso da turma, escopo institucional, grade existente) é do
         * backend. Aqui só reenviamos com `sobrescrever` quando ele pede confirmação.
         */
        materializar (sobrescrever) {
            window.eventBus.$emit('loading', true)

            const payload = {
                matriz_curricular_id: this.matrizId,
                matriz_etapa_id: this.etapaId,
                turma_id: this.turmaId,
                sobrescrever: !!sobrescrever
            }

            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/materializarParaTurma`,
                payload,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)

                const erro = this.msgErro(r)
                if (erro) {
                    if (!sobrescrever && this.pedeConfirmacao(erro)) {
                        this.$msgbox.confirm(erro, 'Atenção', {
                            confirmButtonText: 'Substituir a grade', cancelButtonText: 'Cancelar', type: 'warning'
                        }).then(() => this.materializar(true)).catch(() => {})
                        return
                    }
                    window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                    return
                }

                const d = r.data || {}
                const detalhe = `${d.criados || 0} disciplina(s) gravada(s)` + (d.removidos ? `, ${d.removidos} substituída(s)` : '') + '.'
                this.modalVisivel = false
                window.eventBus.$emit('alert', { msg: (d.mensagem || 'Grade gerada.') + ' ' + detalhe, type: 'success' })
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        enviar (confirmar) {
            window.eventBus.$emit('loading', true)

            const payload = {
                matriz_etapa_id: this.etapaId,
                itens: this.linhas,
                confirmar_remocao: !!confirmar
            }

            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/componentes/salvarLote`,
                payload,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)

                const erro = this.msgErro(r)
                if (erro) {
                    if (!confirmar && this.pedeConfirmacao(erro)) {
                        this.$msgbox.confirm(erro, 'Atenção', {
                            confirmButtonText: 'Salvar mesmo assim', cancelButtonText: 'Cancelar', type: 'warning'
                        }).then(() => this.enviar(true)).catch(() => {})
                        return
                    }
                    window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                    return
                }

                const d = r.data || {}
                const detalhe = `${d.criados || 0} novo(s), ${d.atualizados || 0} atualizado(s), ${d.removidos || 0} removido(s).`
                window.eventBus.$emit('alert', { msg: (d.mensagem || 'Salvo com sucesso.') + ' ' + detalhe, type: 'success' })
                this.load()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
